import { useState } from 'react';

export const LocationButton = ({ onLocationFound }) => {
  const [loading, setLoading] = useState(false);

  const handleGetLocation = () => {
    if (!navigator.geolocation) {
      alert('El servicio de geolocalización no está disponible en este navegador.');
      return;
    }

    setLoading(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const userLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        onLocationFound(userLocation);
        setLoading(false);
      },
      (error) => {
        console.error('Error obteniendo ubicación:', error);
        alert('No se pudo obtener tu ubicación actual.');
        setLoading(false);
      }
    );
  };

  return (
    <button 
      id="center-all-maps"
      onClick={handleGetLocation}
      disabled={loading}
      className="location-button"
    >
      <span className="location-icon">{loading ? '⏳' : '📍'}</span>
      <span className="location-text">{loading ? 'Obteniendo ubicación...' : 'Mi ubicación'}</span>
    </button>
  );
};

